<template>
	<div class="main-containter" v-title data-title="和华利盛">
		<FHeader :checkId="25"></FHeader>
		<!-- <FOtherBanner :name1="'关于我们'" :name2="'About Us'"></FOtherBanner> -->
		<!-- <FTitle></FTitle> -->
		<article ref="article" :style="{height:(previewBoxHeight +725+(item.services.split('、').length * 35))+'px'}">
			<div style="padding-left: 18%;padding-top: 20px;">
				<el-breadcrumb separator="/">
				<el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
				<el-breadcrumb-item  :to="{ path: '/businessArea' }">业务领域</el-breadcrumb-item>
				<el-breadcrumb-item style="color:black">内容详情</el-breadcrumb-item>
			</el-breadcrumb>
			</div>
			<div style="width: 64%;padding: 30px 18%;margin-top:50px;display:flex">
				<div class="left">
					<span style="font-size: 26px;font-weight: 900;color: #98273A;">{{item.title}}</span>
					<span style="padding-top: 5px;color: #98273A;">{{item.e_title}}</span>
					<span style="width: 25px;margin-top: 7px;height: 5px;background-color: #98273A;"></span>
					
					<div style="padding-bottom: 20px;padding-top:20px" ref="previewBox">
						<v-md-preview  style="text-align:left;" :text="item.content" ref="preview"  id="preview"></v-md-preview>
					</div>
				</div>
				<div class="right" style="width:70%;">
					<img style="width: 100%;margin-top: 60px;" :src="item.image" alt="">
				</div>
			</div>
			<div :style="{width: '64%',padding: '30px 18%',height:(item.services.split('、').length * 35)+'px'}">
				<div style="font-size: 18px;border-bottom: 1px solid #D7D7D7;color: #98273A;padding-bottom: 10px;">业务范围</div>
				<div v-for="(item,index) in item.services.split('、')" :key="index" style="font-size: 14px;float: left;padding-top: 40px;width: 33%;">
					<span data-v-6df10058="" style="width: 4px; height: 4px; background-color: rgb(152, 39, 58); display: inline-block; margin-bottom: 3px; margin-right: 10px; margin-left: 10px;"></span>
					<span>{{item}}</span>
				</div>
			</div>
			<div style="width: 64%;padding: 30px 18%;height:450px;">
				<div style="font-size: 18px;border-bottom: 1px solid #D7D7D7;color: #98273A;padding-bottom: 10px;">专业律师</div>
				<el-carousel indicator-position="outside" :autoplay="true">
					<el-carousel-item v-for="(itemList,itemIndex) in lawyerList" :key="itemIndex+10000">
						<div v-for="(item,index) in itemList" :key="index" :style="{'margin-right':index !=4?'3%':'0','font-size': '14px',width: '17.6%',float: 'left','padding-top': '40px'}">
							<!-- {{ lawyerList[itemIndex][index].id}} -->
							<img style="width: 100%;height: 210px;" :src="item.image">
							<div style="text-align: center;margin-top: 10px;width: 100%;">{{item.name}}</div>
							<div style="text-align: center;font-size: 12px;margin-top: 5px;width: 100%;color: #AAAAAA;">
								<span style="padding-right: 5px;border-right: 1px solid;">{{item.company_address}}</span>
								<span style="padding-left: 5px;">{{item.relationship_name}}</span>
							</div>
						</div>
					</el-carousel-item>
				</el-carousel>
				
			</div>
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeaderDetail.vue"
	import { defineComponent, onMounted, reactive, ref, toRefs } from 'vue';
	// import FOtherBanner from "../../components/f/FOtherBanner.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryDetail} from "@/api/service";
	export default {
		name: "Index",
		
		components: {
			FHeader,
			// FOtherBanner,
			Footer
		},
		data() {
			return {
				item: {},
				lawyerList: [],
				previewBoxHeight:375
			}
		},//decodeURIComponent(
		created() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		mounted() {
			this.id = this.$route.query.id
			this.queryDetail()
		},
		activated(){
			this.id = this.$route.query.id
			this.queryDetail()
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			changeId(id){
				this.id = id;
				this.queryDetail()
			},
			queryDetail(){
				let param = {}
				param.id = this.id
				queryDetail(param).then(data => {
						this.item = data.data
						this.lawyerList = []
						for(let i=0;i<data.data.lawyerList.length;i++){
							let itemList = []
							for(let j=0;j<5 && i<data.data.lawyerList.length;i++,j++){
								// data.data.lawyerList[i].index = 1*100+j
								itemList.push(data.data.lawyerList[i])
							}
							this.lawyerList.push(itemList)
						}
						console.log(this.lawyerList)
						let that = this
						this.$nextTick(() => {
							if(this.$refs.previewBox.offsetHeight>375){
								this.previewBoxHeight = this.$refs.previewBox.offsetHeight
							}else{
								this.previewBoxHeight = 375
							}
							console.log(this.$refs.previewBox.offsetHeight)
							
							this.$forceUpdate();
						})
					}).catch(error => {
						this.$message.error(error)
				})
			},
		}
	}
</script>
<style lang="scss" scoped="scoped">

	span /deep/ .el-breadcrumb__inner{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: default !important;
	}
	span /deep/ .el-breadcrumb__inner.is-link{
		font-weight: 400 !important;
		color: #606266 !important;
		cursor: pointer !important;
	}
.left{
			width: 110%;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
		}
		.right{
		padding-left: 7%;
    height: 100%;
		}
div /deep/ .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-carousel__container{
	height: 310px;
}
// div /deep/ .el-carousel__indicators--outside{
// 	display: none;
// }
div /deep/ .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div /deep/ .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div /deep/ .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div /deep/ .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div /deep/ .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div /deep/ .el-pagination{
	text-align: center;
}
</style>
